import React from 'react';
import './Qualifications.css';
import { 
    FaGraduationCap, 
    FaCalendarAlt, 
    FaBookOpen, 
    FaCertificate, 
    FaCheckCircle,
    FaMedal
} from 'react-icons/fa';

import { educationData, certificationsData } from '../data/qualificationsData';

const Qualifications = () => {
    return (
        <section className="qualifications-section" id="credentials">
            <div className="cyber-grid"></div>
            <div className="section-container">
                <div className="section-header">
                    <span className="section-badge">EDUCATION &amp; CERTIFICATIONS</span>
                    <h2 className="section-title">Academic Foundations &amp; Verified Credentials</h2>
                    <p className="section-subtitle">
                        Formal 4-year computer science pedagogy, theoretical systems rigor, and verified professional accreditations.
                    </p>
                </div>

                <div className="qualifications-container">
                    {/* Top Flagship: Academic Pedigree & CS Rigor */}
                    <div className="qual-card academic-card" id="education">
                        <div className="qual-card-header">
                            <div className="qual-header-top">
                                <div className="qual-icon-badge">
                                    <FaGraduationCap className="qual-icon" />
                                </div>
                                <div className="qual-header-meta">
                                    <span className="qual-card-tag">
                                        {educationData.tag === educationData.honor ? 'Undergraduate Pedagogy' : educationData.tag}
                                    </span>
                                    <h3 className="qual-card-title">{educationData.degree}</h3>
                                </div>
                            </div>
                            <div className="qual-meta-chips">
                                <div className="qual-period-chip">
                                    <FaCalendarAlt className="qual-cal-icon" />
                                    <span>{educationData.period}</span>
                                </div>
                                <div className="qual-honor-chip">
                                    <FaMedal className="qual-medal-icon" />
                                    <span>{educationData.honor}</span>
                                </div>
                            </div>
                        </div>

                        <div className="edu-institution-line">
                            <div className="edu-inst-primary">
                                <span className="inst-name">{educationData.institution}</span>
                                <span className="inst-bullet">•</span>
                                <span className="inst-loc">{educationData.location}</span>
                            </div>
                            <div className="edu-inst-accreditations">
                                <span className="inst-bullet desktop-only">•</span>
                                <span className="inst-affil">AICTE Approved</span>
                                <span className="inst-bullet">•</span>
                                <span className="inst-affil">MAKAUT Affiliated</span>
                            </div>
                        </div>

                        <div className="academic-card-body">
                            <div className="coursework-block">
                                <span className="coursework-label">
                                    <FaBookOpen className="book-mini-icon" /> Core Academic Disciplines:
                                </span>
                                <div className="coursework-chips">
                                    {educationData.coreDisciplines.map((chip, idx) => (
                                        <span className="cw-chip" key={idx}>{chip}</span>
                                    ))}
                                </div>
                            </div>

                            <div className="cs-foundations-block">
                                <h4 className="cs-foundations-title">Theoretical Foundations &amp; Systems Rigor:</h4>
                                <div className="cs-foundations-grid">
                                    {educationData.theoreticalFoundations.map((item, idx) => (
                                        <div className="cs-foundation-item" key={idx}>
                                            <FaCheckCircle className="cs-check-icon" />
                                            <div className="cs-foundation-content">
                                                <strong className="cs-area-name">{item.area}:</strong>{' '}
                                                <span className="cs-area-detail">{item.detail}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Flagship: Verified Accreditations 2x2 Balanced Grid */}
                    <div className="qual-card cert-card-full">
                        <div className="qual-card-header">
                            <div className="qual-header-top">
                                <div className="qual-icon-badge purple">
                                    <FaCertificate className="qual-icon purple" />
                                </div>
                                <div className="qual-header-meta">
                                    <span className="qual-card-tag purple">Industry Credentials</span>
                                    <h3 className="qual-card-title">Verified Accreditations</h3>
                                </div>
                            </div>
                        </div>

                        <div className="certs-grid-2x2">
                            {certificationsData.map((c, idx) => (
                                <div className="cert-row" key={idx}>
                                    <div className="cert-row-top">
                                        <h4 className="cert-row-title">{c.title}</h4>
                                        <span className="cert-badge">{c.tag}</span>
                                    </div>
                                    <div className="cert-row-issuer">{c.issuer} • {c.period}</div>
                                    <div className="cert-row-skills">{c.skills}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Qualifications;
